export function isValidEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function isValidTel(tel) {
    const re = /^\d{4,11}$/
    return re.test(tel);
}

export function isValidMobile(mobile) {
    const re = /^9\d{9,9}$/
    return re.test(mobile);
}